<template lang="pug">
.component-sort-table.md-table.md-theme-white(v-if="columns" md-fixed-header v-bind:style="'height: ' + tableHeight + ';'" v-bind:class="{ 'compact-header': compactHeader }")
  .md-toolbar.md-table-toolbar.md-transparent
    slot(name="head")
  .md-content.md-table-content.can-scroll(ref="tableContent")
    table.sort-table(ref="table")
      thead.fixed-head(v-if="!noHead")
        tr
          th.md-table-head(
            v-for="(column, index) in columns" v-bind:key="('th-' + index)" v-bind:ref="'thead-item-' + index" @click="changeSort(column.field)" 
            v-bind:class="{[`component-sort-table__${column.field}`]: true, 'md-sortable': typeof column.sortable != 'undefined' && column.sortable, 'md-sorted': typeof column.sortable != 'undefined' && column.sortable && orderBy == column.field }"
          )
            //div.hidden-head-item.md-table-head-label(v-bind:class="{'hidden-checkbox': (column.field == $props.selectedField), 'sortable': column.field == orderBy}" v-html="column.label")
            .md-table-head-container.md-ripple(v-bind:class="{'selected': (column.field == $props.selectedField)}")
              .md-table-head-label.sort-table__head-label(v-if="column.field != $props.selectedField" v-bind:class="{ 'sortable': column.field == orderBy }")
                span.sort-table__head-label-text(v-html="column.label")
                md-icon.md-table-sortable-icon.sort-table__head-icon(v-if="column.field == orderBy") {{ orderType == 'desc' ? 'arrow_downward' : 'arrow_upward' }}
              .md-table-head-label.selected-fields.fake-checkbox(v-if="column.field == $props.selectedField")
                md-checkbox(v-model="selectAll" v-if="!selectItem.length || selectItem.length == value.length")
                md-checkbox.indeterminate(v-model="unselectAll" v-if="selectItem.length && selectItem.length != value.length")
      transition-group(tag="tbody" name="row")
        tr.md-table-row.link.drag-item(
          v-for="(item, i) in value"
          v-if="link && item && item.routerLink"
          v-bind:key="('tr-' + i)" v-bind:to="item.routerLink"
          v-bind:class="{'selected': item.selected, 'pointer': (($props.cursor) ? 'pointer': '')}"

          v-on:click="linkClick($event, item, i, $props.linkTarget)"
          v-on:click.middle.prevent="linkClick($event, item, i, '_blank')"
          v-on:mousedown.middle.prevent.stop=""
        )
          td.md-table-cell(
            v-for="(column, index) in columns"
            v-bind:ref="'tbody-item-' + i + '-' + index" 
            v-bind:class="{'actions': (column.field == 'actions'), right: index == columns.length - 1, 'left-margin': !index, 'no-breack':  ($props.noBreackColumns.indexOf(column.field)+1), ['cell-field-' + column.field]: true}"
            v-bind:style="(($props.columnsStyles && $props.columnsStyles[column.field]) ? $props.columnsStyles[column.field] : '') + (column.width ? ('width: ' + column.width) : '')"
          )
            div(v-bind:class="{'md-table-cell-container': true, 'selected-fields': ($props.selectedField == column.field)}")
              
              .fake-checkbox(v-if="$props.selectedField == column.field" v-on:click.stop.prevent="toggleSelected(parseInt(item[$props.selectItemField]))")
                md-checkbox(v-if="$props.selectedField == column.field" v-model="selectItem" v-bind:value="parseInt(item[$props.selectItemField])")
              
              slot(v-else v-bind:name="column.field" v-bind:item="item")
                | {{ item[column.field] }}
        template(v-for="(item, index) in value" v-if="!link")
          tr.md-table-row(
            v-bind:key="('tr-' + index)" v-bind:ref="'tbody-item-' + index"  v-on:click="itemClick(index, item)"
            v-bind:class="{ expandable: expandable, active: index == showRow, 'selected': item.selected, 'pointer': (($props.cursor) ? 'pointer': '')}"
          )
            td.md-table-cell(
              v-for="(column, index) in columns" 
              v-bind:class="{ 'actions': (column.field == 'actions'), right: index == columns.length - 1, 'left-margin': !index, 'no-breack':  ($props.noBreackColumns.indexOf(column.field)+1), ['cell-field-' + column.field]: true}"
              v-bind:style="(($props.columnsStyles && $props.columnsStyles[column.field]) ? $props.columnsStyles[column.field] : '') + (column.width ? ('width: ' + column.width) : '')"
            )
              div(v-bind:class="{'md-table-cell-container': true, 'selected-fields': ($props.selectedField == column.field)}")
                
                .fake-checkbox(v-if="$props.selectedField == column.field" v-on:click.stop.prevent="toggleSelected(parseInt(item[$props.selectItemField]))")
                  md-checkbox(v-if="$props.selectedField == column.field" v-model="selectItem" v-bind:value="parseInt(item[$props.selectItemField])")

                slot(v-else v-bind:name="column.field" v-bind:item="item")
                  | {{ item[column.field] }}
          tr.md-table-row(v-bind:key="index" v-if="expandable && showRow == index" v-bind:class="{'pointer': (($props.cursor) ? 'pointer': '')}")
            td.md-table-cell(v-bind:colspan="columns.length")
              slot(name="expanded" v-bind:item="item")
              
  .fixed-footer(v-bind:class="{'loading': loading}" v-if="!$props.noFooter")
    //настройки количества элементов на странице и пагинатор страниц
    .page-options
      .actions
        slot(name="buttons")
          md-button.md-dense(v-on:click="create" v-if="$props.showAddButton") Добавить #[md-icon add]
      .pages(v-if="perPage != 'all' && !cursorPagination")
        template(v-if="totalPages > 1")
          md-button.page.md-icon-button.small(@click="refresh(orderBy, 1, true)"          v-bind:disabled="page <= 1"): md-icon first_page
          md-button.page.md-icon-button.small(@click="refresh(orderBy, page - 1, true)"   v-bind:disabled="page <= 1"): md-icon keyboard_arrow_left
          md-button.page.md-icon-button.small(@click="refresh(orderBy, pageNumber, true)" v-for="pageNumber in totalPages" v-bind:key="pageNumber" v-if="pageNumber > (page - 6) && pageNumber < (page + 6)" v-bind:disabled="pageNumber == page") {{ pageNumber }}
          md-button.page.md-icon-button.small(@click="refresh(orderBy, page + 1, true)"   v-bind:disabled="page >= totalPages"): md-icon keyboard_arrow_right
          md-button.page.md-icon-button.small(@click="refresh(orderBy, totalPages, true)" v-bind:disabled="page >= totalPages"): md-icon last_page
      .pages(v-if="cursorPagination && !isLastPage")
        md-button.md-dense(v-on:click="nextCursor") Загрузить больше #[md-icon keyboard_arrow_right]
      .per-page
        .md-caption Кол-во
        z-select(v-model="perPageCurrent" v-on:change="changePerPage")
          option(v-for="perPageValue in perPageList" v-bind:key="perPageValue" v-bind:value="perPageValue") {{ perPageValue }}
        md-tooltip Количество элементов на странице
</template>

<script>
  import ZCheck from './ZCheck';
  import ZSelect from './ZSelect';
  export default {
    name: 'sort-table',
    components: {ZSelect},
    props: {
      isLastPage: {
        type: Boolean,
        default: false,
      },
      cursorPagination: {
        type: Boolean,
        default: false,
      },
      pageFromQuery: {
        type: Boolean,
        default: true
      },
      refreshOnCreate: {
        type: Boolean,
        default: true
      },
      loadOnScroll: {
        type: Boolean,
        default: false
      },
      compactHeader: {
        type: Boolean,
        default: false
      },
      showAddButton: {
        type: Boolean,
        default: true
      },
      tableHeight: { //высота таблицы
        type: String,
        default: '100%'
      },
      noBreackColumns: { //Колонки, у которых текст не будет переносится на новую строку
        type: Array,
        default: () => []
      },
      columnsStyles:{
        type: Object,
        default: () => {}
      },
      columns: Array, //масив колонок таблицы
      value: Array, //массив элементов, которые отображются в таблице
      perPage: {//кол-во элементов на странице
        default: 25
      },
      selectedField: { //поле элемента, которе используется для выбора при помощи чекбоксов
        type: String,
        default: 'select'
      },
      selectItemField: { //Поле, которе будет добавляться в массив при чеке чекбокса
        type: String,
        defailt: 'id'
      },
      total: Number, //общее кол-во элементов
      link: Boolean, //если true, то строка таблицы является ссылкой. у элемента таблицы должно быть поле routerLink, содержащее объект ссылки
      expandable: Boolean, //если true, то при клике по строке таблице, под строкой будет раскрываться блок с контентом
      noHead: { //если true, то таблица не будет иметь thead
        type: Boolean,
        default: false,
      },
      noFooter: {
        type: Boolean,
        default: false,
      },
      tableId: String, //идентификатор таблицы. используется для обновления при помощи события,
      defaultSort: String, //поле для сортировки по умолчанию
      defaultOrder: String, //направление сортировки по умолчанию. asc - по возрастанию, desc - по убыванию
      perPageList: {
        type: Array,
        default() { return [25, 50, 100] }
      }, //массив с вариантами для списка выбора кол-ва элементов на страницу
      cursor: {
        type: String,
        default: 'default'
      },
      linkTarget: {
        type: String,
        default: '_self'
      }
    },
    data() {
      return {
        orderBy: typeof this.defaultSort != 'undefined' ? this.defaultSort : this.columns[0].field,
        orderType: typeof this.defaultOrder != 'undefined' ? this.defaultOrder : 'desc',
        page: 1,
        showRow: null,
        perPageCurrent: 25,
        perPageObject: {},
        selectAll: false,
        unselectAll: false,
        selectItem: [],
        loading: false,
      }
    },
    computed: {
      totalPages() {
        return Math.ceil(this.total / this.perPageCurrent)
      }
    },
    methods: {
      nextCursor() {
        this.refresh(this.orderBy, this.$props.cursor, false);
      },
      refresh(orderBy, page, reload) {
        if (this.$props.isLastPage && !reload) return;
        this.loading = true;
        if (this.perPageCurrent < 25)  this.perPageCurrent = 25;
        if (this.perPageCurrent > 100) this.perPageCurrent = 100;

        if (reload && this.$refs.tableContent) this.$refs.tableContent.scrollTop = 0;

        let query = Object.assign({}, this.$route.query);
        let columnToSort = {};
        this.columns.forEach(column => {
          if (column.field === orderBy) columnToSort = column
        });
        if (typeof page === 'undefined' && !columnToSort.sortable) {
          this.loading = false;
          return false;
        }
        if (this.orderBy === orderBy && !page) this.orderType = this.orderType === 'desc' ? 'asc' : 'desc';
        else {
          if (page) this.page = page;
          if (!this.page && !this.cursorPagination) this.page = 1;
          this.orderBy = orderBy;
        }
        query.page = this.page;
        if (this.perPage !== 'all') query.perpage = this.perPageCurrent;
        query.orderBy = this.orderBy;
        query.orderType = this.orderType;
        if (this.$props.loadOnScroll) {
          if (reload) query.load_on_scroll = false;
          else query.load_on_scroll = true;
        }

        this.$router.push({name: this.$route.name, params: this.$route.params, query: query});

        this.$emit('refresh', this.page, this.perPageCurrent, this.orderBy, this.orderType, null, reload);
      },
      changeSort(field) {
        let item = this.$props.columns.find(fieldItem => fieldItem.field == field);
        if (item.sortable) this.refresh(field, null, true);
      },
      linkClick(e, item, index, type) {
        this.$emit('item-click', {index: index, item: item});
        if (!item.routerLink) return
        if (type == '_blank') window.open((this.$router.resolve(item.routerLink)).href, type);
        else this.$router.push(item.routerLink)
      },
      itemClick(index, item) {
          this.$emit('item-click', {index: index, item: item});
          this.expand(index);
      },
      toggleSelected(value) {
        let i = this.selectItem.indexOf(value);
        if ((i+1)) this.selectItem.splice(i, 1);
        else this.selectItem.push(value);
      },
      expand(index) {
        if (!this.expandable) return;
        if (parseInt(this.showRow) === parseInt(index))
          this.showRow = null;
        else {
            this.showRow = index;
            this.$emit('expand', index, this.$props.value[index]);
        }
      },
      reload() {
        if (this.$route.query.page) this.page = Number(this.$route.query.page);
        if (this.$route.query.orderBy) this.orderBy = this.$route.query.orderBy;
        this.refresh(this.orderBy, this.page);
      },
      calcHeadWidth() {
        if (!this.$props.columns || !this.$props.columns.length || !this.$props.value || !this.$props.value.length) return;

        for (let i = 0; i <= this.columns.length; i++) {
          if (this.$refs[('thead-item-' + i)] && this.$refs[('tbody-item-0-' + i)] && this.$refs[('thead-item-' + i)].length && this.$refs[('tbody-item-0-' + i)].length) {
            let headItem = this.$refs[('thead-item-' + i)][0],
                headItemWidth = 0;
            if (headItem && headItem.querySelector('.md-table-head-container')) {
              headItemWidth = headItem.querySelector('.md-table-head-container').offsetWidth;
              this.$props.value.map((val, j) => {
                let valWidth = this.$refs[('tbody-item-' + j + '-' + i)];
                if (valWidth) {
                  if (typeof valWidth === 'object' && valWidth[0]) valWidth = valWidth[0];
                  valWidth = valWidth.offsetWidth;
                  if (parseInt(headItemWidth) < parseInt(valWidth)) headItemWidth = parseInt(valWidth);
                }
              });
              headItem.querySelector('.md-table-head-container').style.width = headItemWidth + 'px';
            }
          }        
        }
      },
      create() {
        this.$emit('create');
      },
      listeners() {
        if (this.$props.loadOnScroll && this.$refs.tableContent && this.$refs.table) {
          this.$refs.tableContent.addEventListener('scroll', e => {
            let tableHeight     = this.$refs.table.offsetHeight,
                tableViewHeight = this.$refs.tableContent.offsetHeight,
                scrollTop       = e.target.scrollTop + tableViewHeight,
                percentScroll   = (scrollTop * 100) / tableHeight;
            
            if (this.cursorPagination) {
              if (percentScroll >= 90 && !this.loading) this.nextCursor();
            } else if (percentScroll >= 90 && this.totalPages > this.page && !this.loading) {
              this.page++;
              this.refresh(this.orderBy, this.page);
            }
          });
        }

        this.$root.$on('refresh-table', id => {
          if (id == this.$props.tableId) {
            this.page = 1;
            this.refresh(this.orderBy, this.page, true);
          }
        });        
      },
      changePerPage() {
        this.$nextTick(() => {
          this.perPageObject[this.tableId] = this.perPageCurrent;
          localStorage.setItem('perPageObject', JSON.stringify(this.perPageObject));
          this.refresh(this.orderBy, this.page, true);
        });
      },
      changeSelected(selected) {
        if (JSON.stringify(this.selectItem) != JSON.stringify(selected)) this.selectItem = Object.assign([], selected);
      }
    },
    created() {
      //получаем параметры количества товаров из localStorage
      this.perPageObject = (localStorage.getItem('perPageObject')) ? JSON.parse(localStorage.getItem('perPageObject')) : {};

      this.orderBy   = (this.$props.defaultSort)  ? this.defaultSort  : this.columns[0].field;
      this.orderType = (this.$props.defaultOrder) ? this.defaultOrder : 'desc';

      this.columns.forEach(column => {
        if (typeof column.default != 'undefined' && column.default) this.orderBy = column.field
      })
      if (this.$route.query.page && this.$props.pageFromQuery) this.page = Number(this.$route.query.page);
      
      if (this.$route.query.perpage) this.perPageCurrent = Number(this.$route.query.perpage);
      else {
        if (this.perPageObject && this.perPageObject[this.tableId]) this.perPageCurrent = this.perPageObject[this.tableId];
        else this.perPageCurrent = this.perPage;
      }
      if (this.$route.query.orderBy)   this.orderBy   = this.$route.query.orderBy
      if (this.$route.query.orderType) this.orderType = this.$route.query.orderType
      
      if (this.perPageCurrent < 25)  this.perPageCurrent = 25;
      if (this.perPageCurrent > 100) this.perPageCurrent = 100;
      if (this.$props.refreshOnCreate) this.$emit('refresh', this.page, this.perPageCurrent, this.orderBy, this.orderType, null, true);
      
      this.initialized = true
      //обновление таблицы, если вызывается событие reload-table и передано id таблицы
      this.$root.$on('reload-table', id => {
        //id таблицы может быть строкой
        if (id === this.$props.tableId) {
          this.selectAll = false;
          this.selectItem = [];
          this.reload();
        }
      });

      this.$on('clear-selected', () => {
        this.selectAll = false;
        this.selectItem = [];
      });

      this.$nextTick(() => this.listeners());
    },
    watch: {
      'columns'(columns) {
        //if (columns && columns.length) setTimeout(() => this.calcHeadWidth(), 500);
      },
      'value'(o, n) {
        this.loading = false;
        //if (o && o.length) setTimeout(() => this.calcHeadWidth(), 500);
      },
      '$route.name'() {
        //if (this.$props.columns) setTimeout(() => this.calcHeadWidth(), 500);
      },
      'selectAll'(val) {
        if (!val) this.selectItem = [];
        else if (this.$props.value && this.$props.value.length) {
          this.$props.value.map(item => {
            if (item && item[this.$props.selectItemField]) this.selectItem.push(parseInt(item[this.$props.selectItemField])) 
          });
        }
      },
      'unselectAll'(val) {
        if (!val) {
          this.selectItem = [];
          this.selectAll = false;
        }
      },
      'selectItem'(val) {
        if (val.length != this.$props.value.length) this.unselectAll = true;
        this.$emit('change-selected', val);
      }
    }
  }
</script>

<style lang="sass">
.row-enter-active, .row-leave-active
  //transition: transform 0.25s ease-in-out
  //transition: opacity 0.5s ease-in-out
  transition: 0.5s ease-in-out
.row-enter, .row-leave-to
  //transform: translate(0, 51px)
  //transform: scaleY(0)
  opacity: 0
.component-sort-table
  position: relative
  &.compact-header
    .md-toolbar
      position: absolute
      left: 36px
      width: calc(100% - 36px)
      background: #fff
      top: 0
      z-index: 14
      padding-left: 0
      padding-right: 0
      .md-button
        margin: 2px 0
  .no-break-hidden
    display: flex
    align-items: flex-start
    align-items: center
    position: absolute
    overflow: hidden
    min-width: 85%
    width: 85%
    height: 90%
    min-height: 90%
    top: 5%
    z-index: 1
    padding: 0 5px
    white-space: break-spaces
    text-overflow: ellipsis
    word-break: break-all
    *
      max-height: 100%
  .no-break-hidden:hover
    overflow: visible
    z-index: 2
    background: rgb(235, 235, 235)
    height: auto
    white-space: initial
    width: max-content
    max-width: 150%
  .md-table-head-label
    width: 100%
    padding: 2px 5px !important
    &.sortable
      padding-right: 20px
    sup
      line-height: 0px
  .sort-table__head-label
  .sort-table__head-icon
    height: 28px
    position: initial
    transform: none
        
  .md-toolbar
    min-height: auto
    height: auto

  .fixed-head
    top: 0
    position: sticky
    z-index: 14
    background: #fff
    border-bottom: var(--md-theme-white-divider-on-background, rgba(0, 0, 0, 0.12))
    .hidden-checkbox
      padding: 0
    .hidden-head-item
      visibility: hidden
      height: 0px
      display: block
    .md-table-head
      .md-table-head-container
        display: flex
        align-items: center
        justify-content: flex-start
        box-shadow: -1px 0px 1px 0 rgba(0,0,0,.2)
        z-index: 10
        top: 0
        position: relative
        min-height: 36px
      .md-table-head-container.selected
        padding: 0 !important
  .fixed-footer
    position: sticky
    bottom: 0
    left: 0
    right: 0
    background: #fff
    padding: 5px 10px
    z-index: 10
    box-shadow: 1px 0px 1px 0 rgba(0,0,0,.2)
    width: 100%
    transition: 0.25s ease-in-out
    .page-options
      display: flex
      justify-content: space-between
      align-items: center
    .pages
      margin: auto 10px auto auto
    .per-page
      justify-content: flex-end
      display: flex
      align-items: center
      max-width: 150px
      margin: auto 10px auto 10px
      .z-select
        font-size: 12px !important
        height: 24px
        width: 60px
      .md-caption
        min-width: 50px
        padding: 0
    .actions
      .md-button
        margin: 0
  .fixed-footer.loading
    opacity: 0.3
.component-sort-table.md-table
  .sort-table
    overflow: initial
    .md-table-head
      position: initial
      .md-table-head-container
        padding: 2px 0
        height: auto
        width: auto
      &:first-child
        .md-table-head-container
          padding: 2px 0 2px 7px
      .selected-fields
        padding: 7px 5px !important
      .md-checkbox
        margin: 0
        .md-checkbox-container
          width: 18px
          height: 18px
          min-width: 18px
          &::before
            width: 18px
            height: 18px
            min-width: 18px
          &::after
            height: 11px
            left: 4px
          .md-ripple
            width: 18px !important
            height: 18px !important
            min-width: 18px !important
      .md-checkbox.indeterminate
        .md-checkbox-container
          &::after
            width: 14px
            height: 1px
            left: 0px
    .md-table-cell.no-breack
      white-space: nowrap
    .md-table-cell-container.selected-fields
      padding: 0 0 0 5px !important
      .md-checkbox
        margin: 0
        .md-checkbox-container
          width: 18px
          height: 18px
          min-width: 18px
          &::before
            width: 18px
            height: 18px
            min-width: 18px
          &::after
            height: 11px
            left: 4px
          .md-ripple
            width: 18px !important
            height: 18px !important
            min-width: 18px !important
    .sortable
      cursor: pointer
    .md-table-row
      display: table-row
      text-decoration: none
      color: initial
      vertical-align: inherit
      unicode-bidi: isolate
      //transform: scaleY(1)
      .md-table-cell
        height: 32px !important
        padding: 0px !important
        position: relative
        transition: 0.3s ease
        height: 100%
        font-size: 12px
        line-height: 14px
        .md-table-cell-container
          padding: 2px 5px 2px 5px
        .md-table-cell-container > a, .md-table-cell-container > a:hover
          color: inherit
          text-decoration: none
          display: block
        &.right
          text-align: right
          .md-chip
            cursor: pointer
          .md-table-cell-container
            display: flex
            justify-content: flex-end
            align-items: center
        .md-table-cell-container.selected-fields
          padding: 0
          .fake-checkbox
            padding: 0
            width: 18px
            height: 18px
            display: flex
            align-items: center
            justify-content: center
      .md-table-cell.left-margin
        .md-table-cell-container
          padding: 2px 5px 2px 10px
      .actions
        width: 0px
        padding: 0px !important
        margin: 0px !important
        .md-table-cell-container
          visibility: hidden
          transition:  0.45s cubic-bezier(.4,0,.2,1)
          background: transparent
          opacity: 0
          width: 0px
          position: absolute
          top: 0px
          right: 0px
          background: linear-gradient(to right, transparent 0%, rgb(235, 235, 235) 30%)
          height: 100%
          padding: 0px 10px
      .md-checkbox
        opacity: 0.5
        &.md-checked
          opacity: 1
      &:hover
        .md-checkbox
          opacity: 1
        .actions
          z-index: 2
          .md-table-cell-container
            visibility: visible
            width: auto
            opacity: 1
    .md-table-row.selected
        background-color: var(--md-theme-white-highlight-on-background, rgba(0, 0, 0, 0.08))
    .md-table-row.pointer
      cursor: pointer
    .pages
      padding: 0
    .md-table-head .md-icon
      font-size: 14px !important
    .link, .expandable
      cursor: pointer
      &.active
        background: rgba(0, 0, 0, 0.08)

</style>



// WEBPACK FOOTER //
// SortTable.vue?42eee5c9